export default function displayNumberFilterFactory(Utils) {
  'ngInject';

  return function displayNumberFilter(value = '', isFractionAlwaysVisible = false) {
    const decimalFormat = Utils.getDecimalFormat();
    return Utils.formatNumber(value || 0, decimalFormat, isFractionAlwaysVisible);
  };
}
